import { useMemo } from 'react';
import { RTCBar } from 'src/features/RTCBar/RTCBar';
import { VoiceChannelControls } from 'src/features/RTCBar/RTCControls';
import { useLivekitRTCState } from 'src/provider/VoiceChannel/livekit/useLivekitRTCState';
import { AICallChannel } from '../../@types/chat';
import { GatheringCallSidebar } from './GatheringCallSidebar/GatheringCallSidebar';
import { AICallControls } from './RTCControls/AICallControls';
import { GatheringSpacesActions } from './RTCControls/GatheringSpacesActions';

export const GatheringSpacesBar = () => {
  const { activeVoiceChannel, connectionStatus, connectionQuality } =
    useLivekitRTCState();

  const isConnected = useMemo(
    () => !!activeVoiceChannel?.channel?._id,
    [activeVoiceChannel?.channel?._id],
  );
  const isAICall = useMemo(
    () => !!(activeVoiceChannel?.channel as AICallChannel)?.aiCall,
    [activeVoiceChannel?.channel],
  );

  if (!isConnected) return null;
  return (
    <>
      {!isAICall && <GatheringCallSidebar />}
      <RTCBar
        channel={activeVoiceChannel.channel}
        connectionStatus={connectionStatus}
        connectionQuality={connectionQuality}
        isConnected={!!activeVoiceChannel.channel._id}
        participantsCount={activeVoiceChannel.members.length}
      >
        {isAICall ? (
          <AICallControls />
        ) : (
          <>
            <GatheringSpacesActions />
            <VoiceChannelControls />
          </>
        )}
      </RTCBar>
    </>
  );
};
